import { KEYS } from '../../../../../l18n/constants';
import usePartnerProfileTabNavigation from '../../../../../hooks/ui/usePartnerProfileTabNavigation';
import { useL18nContext } from '../../../ContextProvider/L18n';
import { useScreenContext } from '../../../ContextProvider/Screen';
import computeClassName from '../../../../../utils/computeClassName';
import CCTab from '../../../../libs/CiscoCore/Tab';
import PartnerProfileExpertises from './Expertises';
import PartnerProfileOverview from './Overview';

const constants = Object.freeze({
  CLASSNAME_BASE: ''
});

function getComputedTabSize(useLargeTab) {
  return useLargeTab ? 'large':'medium';
}

export default function PartnerExpertisesAndOverview(
  {
    partnerName,
    partnerDescription,
    partnerRolesAndLevels,
    partnerExpertises,
    partnerRoles,
    partnerTechnologies,
    partnerIndustries,
    partnerDiversityProgramNames,
    isDiversePartner,
    className = ''
  }) {

  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);

  const { getTranslationFor } = useL18nContext();
  const translatedExpertiseLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_EXPERTISE);
  const translatedOverviewLabel = getTranslationFor(KEYS.L18N_KEY_LABEL_OVERVIEW);

  const {
    navigateToExpertises,
    navigateToOverview,
    isExpertisesTabActive,
    isOverviewTabActive
  } = usePartnerProfileTabNavigation();

  const { isScreenSMAndUp } = useScreenContext();
  const computedTabSize = getComputedTabSize(isScreenSMAndUp);

  return (
    <div className={computedClassName}>
      <nav className="mb-12 xs:mb-20">
        <div className="px-5 xs:px-0 xs:mx-auto xs:w-8/12">
          <ul className="flex-grow flex items-center border-b border-cc-gray-05">
            <CCTab className="-ml-4"
                   label={translatedExpertiseLabel}
                   tag="li"
                   exposure="low"
                   size={computedTabSize}
                   isActive={isExpertisesTabActive()}
                   activationFn={navigateToExpertises}/>
            <CCTab className=""
                   label={translatedOverviewLabel}
                   tag="li"
                   exposure="low"
                   size={computedTabSize}
                   isActive={isOverviewTabActive()}
                   activationFn={navigateToOverview}/>
          </ul>
        </div>
      </nav>

      <div className="space-y-20">
        <PartnerProfileExpertises className="mb-20"
                                  partnerName={partnerName}
                                  partnerRolesAndLevels={partnerRolesAndLevels}
                                  partnerExpertises={partnerExpertises}/>

        <PartnerProfileOverview className=""
                                partnerName={partnerName}
                                partnerDescription={partnerDescription}
                                partnerRoles={partnerRoles}
                                partnerTechnologies={partnerTechnologies}
                                partnerIndustries={partnerIndustries}
                                isDiversePartner={isDiversePartner}
                                partnerDiversityProgramNames={partnerDiversityProgramNames}/>
      </div>
    </div>
  );

}
